import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Seo } from "@/components/Seo";
import { APP_VERSION } from "@/config/version";
import { Sparkles, AlertTriangle, Rocket } from "lucide-react";

const added = [
  "Beta branding and version indicator across the app.",
  "Floating feedback button on every page (Bug / Improvement / General / Feature Request).",
  "Install App button with iOS 'Add to Home Screen' guide.",
  "Offline detection banner with automatic reconnect.",
  "Friendly 404 and 500 error pages.",
  "Admin Beta Insights dashboard.",
];

const knownIssues = [
  "Mobile Lighthouse Performance is below 90 while we optimise images and fonts.",
  "iOS Safari doesn't support one-tap install; manual instructions are shown instead.",
  "Analytics can take up to a minute to appear in the admin dashboard.",
];

const upcoming = [
  "Faster page loads via route-level code splitting.",
  "Hindi and regional-language UI toggle.",
  "Push notifications for saved programs and deadlines.",
  "Personal dashboard for saved programs (opt-in).",
];

const WhatsNew = () => (
  <div className="min-h-screen flex flex-col">
    <Seo
      title="What's New | We-Help.in Beta"
      description="Recently added features, known issues, and upcoming improvements in the We-Help Beta."
      path="/whats-new"
    />
    <Header />
    <main className="flex-1 container py-12 max-w-3xl">
      <div className="mb-8">
        <span className="inline-flex items-center rounded-full border border-amber-300 bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-800">
          {APP_VERSION}
        </span>
        <h1 className="mt-3 text-3xl md:text-4xl font-bold text-foreground">What's New</h1>
        <p className="mt-2 text-muted-foreground">
          Everything shipped, in progress, and what we're planning next.
        </p>
      </div>

      <Section icon={Sparkles} title="Recently added" items={added} tone="primary" />
      <Section icon={AlertTriangle} title="Known issues" items={knownIssues} tone="amber" />
      <Section icon={Rocket} title="Upcoming improvements" items={upcoming} tone="muted" />
    </main>
    <Footer />
  </div>
);

function Section({
  icon: Icon,
  title,
  items,
  tone,
}: {
  icon: typeof Sparkles;
  title: string;
  items: string[];
  tone: "primary" | "amber" | "muted";
}) {
  const iconClass =
    tone === "primary"
      ? "text-primary bg-primary/10"
      : tone === "amber"
        ? "text-amber-700 bg-amber-100"
        : "text-muted-foreground bg-muted";
  return (
    <section className="mb-8 rounded-2xl border border-border bg-card p-6">
      <h2 className="flex items-center gap-2 text-xl font-bold text-foreground">
        <span className={`inline-flex h-8 w-8 items-center justify-center rounded-lg ${iconClass}`}>
          <Icon className="h-4 w-4" />
        </span>
        {title}
      </h2>
      <ul className="mt-4 space-y-2 text-foreground">
        {items.map((item) => (
          <li key={item} className="flex gap-2">
            <span className="text-muted-foreground">•</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default WhatsNew;